import cx from 'classnames';
import * as React from 'react';
import { callAll } from '../helper/fp';

type ModalDialogProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

/**
 * `ModalDialog` renders a dialog element. You should wrap it with
 * `ModalOverlay` other contents are de-emphasized.
 */
export const ModalDialog: React.FC<ModalDialogProps> = ({ className, onClick, children, ...dialogProps }) => {
  return (
    <div
      className={cx('modal-dialog', className)}
      role="document"
      onClick={callAll(onClick, (ev) => ev.stopPropagation())}
      {...dialogProps}
    >
      <div className="topdk-modal__content">{children}</div>
    </div>
  );
};

export default ModalDialog;
